import React from 'react';
import { isNil } from 'ramda';
import { Button } from '@fasstech/middle-design-system';
import CcnsList from './CcnsList.jsx';
import { isNotNilOrEmpty } from '@@serverHelpers/index.mjs';

const Ccns = ({
  ccns,
  loadingCcns,
  getMiddleText,
  form,
  noCCN,
  setNoCCN,
  otherCcns,
  loadingOtherCcns,
  onSearchOtherCcns,
  options,
  optionsOtherCcns,
  onSearchCcnOffer,
  ccnOffer,
  loadingCcnOffer,
  setCcnOffer,
  setOtherCcns,
  selectedCompany,
  onSearchFlexiproduct,
  validatedCcn,
  redirectionInfo,
  validatedCcnIdRef,
  onSelectCcn,
  canGoNext
}) => {
  return (
    <div className={'flex flex-col w-full'}>
      {isNotNilOrEmpty(selectedCompany.name) && (
        <div className={'font-bold py-2'}>
          {getMiddleText('ENTREPRISE_CCN_IDENTIFIEE_LABEL')}
        </div>
      )}
      <CcnsList
        ccns={ccns}
        loadingCcns={loadingCcns}
        getMiddleText={getMiddleText}
        form={form}
        noCCN={noCCN}
        otherCcns={otherCcns}
        loadingOtherCcns={loadingOtherCcns}
        options={options}
        optionsOtherCcns={optionsOtherCcns}
        onSearchCcnOffer={onSearchCcnOffer}
        ccnOffer={ccnOffer}
        loadingCcnOffer={loadingCcnOffer}
        onSearchFlexiproduct={onSearchFlexiproduct}
        validatedCcn={validatedCcn}
        redirectionInfo={redirectionInfo}
        validatedCcnIdRef={validatedCcnIdRef}
        onSelectCcn={onSelectCcn}
        canGoNext={canGoNext}
      />

      {!isNil(ccns) && (
        <div className={'flex gap-4 py-6'}>
          <Button
            variant={isNotNilOrEmpty(otherCcns) ? 'primary' : 'outline'}
            onClick={() => {
              form.setValue('company.ccnRef', null);
              setCcnOffer(null);
              setNoCCN(false);
              onSearchOtherCcns();
            }}
            data-testid={'ENTREPRISE_CCN_CHOIX_AUTRE_CCN_BOUTON'}
          >
            {getMiddleText('ENTREPRISE_CCN_CHOIX_AUTRE_CCN_BOUTON_LABEL')}
          </Button>
          <Button
            variant={!noCCN ? 'outline' : 'primary'}
            onClick={() => {
              setCcnOffer(null);
              setNoCCN(true);
              setOtherCcns(null);
              onSearchCcnOffer();
              onSearchFlexiproduct();
            }}
            data-testid={'ENTREPRISE_CCN_NON_CCN_BOUTON'}
          >
            {getMiddleText('ENTREPRISE_CCN_NON_CCN_BOUTON_LABEL')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default Ccns;
